import { useEffect } from 'react';

export default function MobileModalFocusGuard() {
  useEffect(() => {
    if (!globalThis.matchMedia?.('(max-width: 820px)').matches) return undefined;

    let lastModal = null;

    const clearInitialModalFocus = () => {
      const modal = document.querySelector('.modal-backdrop .modal-card');
      if (!modal || modal === lastModal) return;
      lastModal = modal;

      // Create Lead manages its own mobile focus. Blurring here races intentional
      // taps/autofocus during Match → Lead and can dismiss the software keyboard.
      if (modal.classList.contains('create-lead-compact')) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const active = document.activeElement;
          if (active && modal.contains(active) && active.matches('input, textarea, select, [contenteditable="true"]')) {
            active.blur();
          }
        });
      });
    };

    const observer = new MutationObserver(clearInitialModalFocus);
    observer.observe(document.body, { childList: true, subtree: true });
    clearInitialModalFocus();

    return () => observer.disconnect();
  }, []);

  return null;
}
